'use strict'

angular.module('utils').filter('telephone', [
	function () {
		//Index 0: always empty string (don't know why)
		//Index 1: DDI + DDD
		//Index 2: DDI
		//Index 3: DDD
		//Index 4: first 4 or 5 numbers
		//Index 5: last 4 numbers
		//Index 6: always empty string (don't know why)
		//var regExp = /^(\+?\s*?(55)?\s*?\(?\s*?([1-9]{2})\s*?\)?)\s*?([0-9]{4,5})\s*?\-?\s*?([0-9]{4})$/

		function normalize(input) {
			return input && input.length > 0 ? input.replace(/[^0-9\+]/g, '') : null
		}

		function isValid(input) {
			var regExp = /^\+?[0-9]{1,3}\s?[0-9\s\-\(\)]{5,}$/
			if (!regExp.test(input)) {
				return false
			}

			// Verificar se o código do país está presente (mínimo 2 dígitos)
			if (input.startsWith('+') && input.length < 3) {
				return false
			}

			return true
		}

		function format(input, onlyNumbers, removeDDI) {
			/*var parts = input.split(regExp)
			var ddi = parts[2]
			var ddd = parts[3]
			var firstNumbers = parts[4]
			var lastNumbers = parts[5]*/
			if (onlyNumbers) {
				return input.replace(/\D/g, '')
			} else {
				return input.replace(/[^0-9\+]/g, '').replace(/(\+\d{2})(\d{2})(\d{4,5})(\d{4})/, '$1 ($2) $3-$4')
			}
		}

		return function (input, onlyNumbers, removeDDI) {
			if (!input) {
				return null
			}

			input = normalize(input)

			/*if (!normalize(input) || normalize(input).length == 0) {
				return null
			}*/

			if (!isValid(input)) {
				return null
			}

			return format(input, onlyNumbers, removeDDI)
		}
	},
])
